import _toConsumableArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import utils from '../../../../utils';
import dompurify from 'dompurify';
/** @type {Array<import("../logic/types").EcrionFormFieldType} */

var INPUT_FIELDS = ['checkbox', 'checkboxgroup', 'currency', 'date', 'datetime', 'dropdown', 'file', 'googleaddress', 'image', 'number', 'password', 'radiogroup', 'signature', 'textarea', 'textbox', 'time'];
/**
 * Check if specified field is an input field type
 * @param {import("../logic/types").EcrionFormFieldType} type
 */

var isInputField = function isInputField(type) {
  return INPUT_FIELDS.includes(type);
};

var sanitizer = dompurify.sanitize;

var getHtmlMarkup = function getHtmlMarkup(html) {
  if (!html) return html;

  try {
    var newHtml = "".concat(html);
    var dom = utils.string2xml(sanitizer(newHtml), 'text/html');
    var documentElement = dom.documentElement;
    if (!documentElement) return '';
    if (documentElement.localName === 'parsererror') return '';
    if (!documentElement.firstChild) return '';
    if (documentElement.firstChild.localName === 'parsererror') return '';
    var bodyElements = documentElement.getElementsByTagName('body');
    if (bodyElements && bodyElements.length) return bodyElements[0].innerHTML; // fallback

    return documentElement.innerText;
  } catch (_unused) {
    return '';
  }
};

var cleanupHtmlMarkup = function cleanupHtmlMarkup(html) {
  if (!html) return html;

  try {
    var newHtml = "".concat(html);
    var dom = utils.string2xml(newHtml, 'text/html');
    var documentElement = dom.documentElement;
    if (!documentElement) return '';
    if (documentElement.localName === 'parsererror') return '';
    if (!documentElement.firstChild) return '';
    if (documentElement.firstChild.localName === 'parsererror') return '';
    var bodyElements = documentElement.getElementsByTagName('body');
    if (bodyElements && bodyElements.length) return bodyElements[0].innerText; // fallback

    return documentElement.innerText;
  } catch (_unused2) {
    return '';
  }
};

var parseFieldPermissions = function parseFieldPermissions(permsValue) {
  if (!permsValue) return [];
  return permsValue.split(',');
};

var hasPermission = function hasPermission(userPermissions, fieldPermissions) {
  // if no field permissions specified, then everyone has permissions
  if (!fieldPermissions || !fieldPermissions.length) return true; // if no user permissions specified, then we give permission

  if (!userPermissions || !userPermissions.length) return true; // check if at least one field permission is included in user permissions

  return fieldPermissions.some(function (fieldPerm) {
    return userPermissions.includes(fieldPerm);
  });
};
/**
 * Read default values from fields and set field data
 * @param {Array<import('../logic/types').EcrionFormField>} fields
 * @param {import('../logic/types').EcrionFormState} state
 */


var readDefaultValues = function readDefaultValues(fields, state) {
  if (!fields || !fields.length) return;
  fields.forEach(function (field) {
    var fieldId = field.id;
    var defaultValue = field.defaultValue;
    if (typeof defaultValue !== 'string') return; // no default value

    if (!defaultValue) return; // value depends on context, so it will be processed later

    if (defaultValue.search(/{[^}]+}?}/g) >= 0) return;
    state.data[fieldId] = defaultValue;
  });
};
/**
 * @param {import('../logic/types').EcrionFormField} field
 * @return {string}
 */


var findContextSuffix = function findContextSuffix(field) {
  if (!field || !field.originalId) return '';
  if (field.id.startsWith(field.originalId)) return field.id.substring(field.originalId.length);
  return '';
};
/**
 * @param {string} fieldId
 * @param {string} originalFieldId
 * @return {string}
 */


var findContextSuffixFromIds = function findContextSuffixFromIds(fieldId, originalFieldId) {
  if (!fieldId || !originalFieldId) return '';
  if (fieldId.startsWith(originalFieldId)) return fieldId.substring(originalFieldId.length);
  return '';
};
/**
 * Check if the field is in the same repeating context as sourceField
 * @param {import('../logic/types').EcrionFormState} state
 * @param {import('../logic/types').EcrionFormField} field
 * @param {import('../logic/types').EcrionFormField} sourceField
 */


var hasCommonRepeatingContext = function hasCommonRepeatingContext(state, field, sourceField) {
  if (!sourceField) return false; // no source field (sanity check)

  if (!sourceField.originalId) return true; // not in a repeating context so we assume the same context

  var fieldContextSuffix = findContextSuffix(field);
  var sourceFieldContextSuffix = findContextSuffix(sourceField);
  return fieldContextSuffix.startsWith(sourceFieldContextSuffix);
};
/**
 * Check if the field is in the same repeating context as sourceField
 * @param {import('../logic/types').EcrionFormState} state
 * @param {import('../logic/types').EcrionFormField} field
 * @param {import('../logic/types').EcrionFormField} sourceField
 * @return {Attay<>} A list of cloned fields for 'field' that are in the same context as sourceField
 */


var findClonedFieldsInSameRepeatingContext = function findClonedFieldsInSameRepeatingContext(state, field, sourceField) {
  var fields = Object.keys(state.fields).map(function (id) {
    return state.fields[id];
  });
  var clonedFields = fields.filter(function (f) {
    return f.originalId === field.id;
  }) || [];
  if (clonedFields.length === 0) return [state.fields[field.id]];
  return clonedFields.filter(function (f) {
    return hasCommonRepeatingContext(state, f, sourceField);
  });
};
/**
 * Check if the field has clones in the form
 * @param {import('../logic/types').EcrionFormState} state
 * @param {import('../logic/types').EcrionFormField} field
 */


var hasClones = function hasClones(state, field) {
  if (!field) return false;
  var fields = Object.keys(state.fields).map(function (id) {
    return state.fields[id];
  }); // a field has clones only if exists at least one field with the original id the same with the field id

  return !!fields.find(function (f) {
    return f.originalId === field.id;
  });
};
/**
 * Return all cloned of the current field if any
 * @param {import('../logic/types').EcrionFormState} state
 * @param {import('../logic/types').EcrionFormField} field
 */


var getClones = function getClones(state, field) {
  if (!field) return [];
  var fields = Object.keys(state.fields).map(function (id) {
    return state.fields[id];
  }); // a field has clones only if exists at least one field with the original id the same with the field id

  return fields.filter(function (f) {
    return f.originalId === field.id;
  });
};
/**
 * @param {import('../logic/types').EcrionFormState} state
 * @param {import('../logic/types').EcrionFormField} field
 */


var findFieldIndex = function findFieldIndex(state, field) {
  var parentField = state.fields[field.parentId];
  if (!parentField || parentField.type !== 'repeating') return 0;

  while (parentField && parentField.type === 'repeating') {
    var parent = state.fields[parentField.parentId];
    if (parent && parent.type === 'repeating') parentField = parent;else break;
  }

  if (!parentField) return 0;
  var fieldIds = collectSimilarFields(state, parentField, field);
  if (fieldIds.length === 0) return 0;
  return fieldIds.indexOf(field.id);
};
/**
 * @param {import('../logic/types').EcrionFormState} state
 * @param {import('../logic/types').EcrionFormField} field
 * @param {import('../logic/types').EcrionFormField} contextField
 */


var findFieldSuffixByContext = function findFieldSuffixByContext(state, field, contextField) {
  if (!field || !contextField) return '';
  var parentField = state.fields[field.parentId];
  var parentFieldId = parentField.originalId || parentField.id;

  while (contextField) {
    var contextParentField = state.fields[contextField.parentId];
    if (!contextParentField) return '';
    var contextParentFieldId = contextParentField.originalId || contextParentField.id;
    if (parentFieldId == contextParentFieldId) return findContextSuffix(contextField);
    contextField = state.fields[contextField.parentId];
  }

  return '';
};
/**
 * @param {import('../logic/types').EcrionFormState} state
 * @param {import('../logic/types').EcrionFormField} container
 * @param {import('../logic/types').EcrionFormField} field
 * @returns
 */


var collectSimilarFields = function collectSimilarFields(state, container, field) {
  if (container.type !== 'repeating') return [];
  var fieldIds = [];
  container.childrenMap.forEach(function (item) {
    var fields = item.children.map(function (childId) {
      return state.fields[childId];
    });
    var targetField = fields.find(function (f) {
      return f.originalId === field.originalId;
    });
    if (targetField) fieldIds.push(targetField.id);else fields.forEach(function (f) {
      fieldIds.push.apply(fieldIds, _toConsumableArray(collectSimilarFields(state, f, field)));
    });
  });
  return fieldIds;
};
/**
 * @param {import('../logic/types').EcrionFormState} state
 * @param {Array<string>} fieldIds
 * @return {Array<import('../logic/types').EcrionFormField>}
 */


var collectFieldsForVisbilityChanged = function collectFieldsForVisbilityChanged(state, fieldIds) {
  var fields = [];
  fieldIds.forEach(function (fieldId) {
    var field = state.fields[fieldId];
    if (fields.includes(field)) return;
    fields.push(field);

    if (field.type === 'repeating') {
      field.childrenMap && field.childrenMap.forEach(function (item) {
        fields.push.apply(fields, _toConsumableArray(collectFieldsForVisbilityChanged(state, item.children)));
      });
    }
  });
  return fields;
};
/**
 * @param {import('../logic/types').EcrionFormState} state
 * @param {string} fieldId
 * @param {string} ancestorId
 * @returns {boolean}
 */


var fieldHasAncestor = function fieldHasAncestor(state, fieldId, ancestorId) {
  if (!fieldId) return false;
  if (fieldId === ancestorId) return true;
  var field = state.fields[fieldId];
  return fieldHasAncestor(state, field && field.parentId, ancestorId);
};

export default {
  isInputField: isInputField,
  getHtmlMarkup: getHtmlMarkup,
  cleanupHtmlMarkup: cleanupHtmlMarkup,
  parseFieldPermissions: parseFieldPermissions,
  hasPermission: hasPermission,
  readDefaultValues: readDefaultValues,
  findFieldSuffixByContext: findFieldSuffixByContext,
  findContextSuffixFromIds: findContextSuffixFromIds,
  findContextSuffix: findContextSuffix,
  hasCommonRepeatingContext: hasCommonRepeatingContext,
  findClonedFieldsInSameRepeatingContext: findClonedFieldsInSameRepeatingContext,
  collectFieldsForVisbilityChanged: collectFieldsForVisbilityChanged,
  hasClones: hasClones,
  getClones: getClones,
  findFieldIndex: findFieldIndex,
  fieldHasAncestor: fieldHasAncestor
};